import { lazy } from 'react';

class CodeSplitter {
  constructor() {
    this.components = {};
  }

  addComponent(path, key) {
    if (!this.components[key]) {
      // eslint-disable-next-line no-use-before-define
      this.components[key] = lazy(() => import(`../${path}`));
    }
  }

  getComponent(key) {
    return this.components[key];
  }
}

export default new CodeSplitter();
